<template>
  <IconBase class="animate-spin" style="animation-duration: 3s">
    <IconRefresh/>
  </IconBase>
</template>

<script>
import IconBase from "./icons/IconBase";
import IconRefresh from "./icons/wflwr/IconRefresh";

export default {
  components: {IconRefresh, IconBase}
}
</script>